import { useEffect, useState } from 'react';
// Both dimensions, not just width, so a phone turned sideways (short side
// still under ~430pt) is never misclassified as a tablet (iPad's short side
// starts at ~744pt), regardless of current orientation.
const query = '(min-width: 700px) and (min-height: 700px)';
const readTablet = () => window.matchMedia?.(query).matches ?? false;
export default function useIsTablet() {
  const [isTablet, setIsTablet] = useState(readTablet);
  useEffect(() => {
    const media = window.matchMedia?.(query);
    if (!media) return undefined;
    const update = () => setIsTablet(media.matches);
    update();
    media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);
  return isTablet;
}
